(function() {
  if (window.articleMagazineReady) return;
  window.articleMagazineReady = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function slugify(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .slice(0, 80);
  }

  function initArticle(root) {
    if (!root || root.dataset.articleMagazineInitialized === 'true') return;
    root.dataset.articleMagazineInitialized = 'true';
    var content = root.querySelector('[data-article-content]') || root;
    var nav = root.querySelector('[data-article-section-nav]');
    if (!content || !nav) return;

    var headings = Array.from(content.querySelectorAll('h2[data-nav-label]')); 
    if (!headings.length) {
      nav.hidden = true;
      return;
    }

    nav.innerHTML = '';
    headings.forEach(function(heading, index) {
      if (!heading.id) heading.id = slugify(heading.textContent) || 'story-section-' + (index + 1);
      var label = heading.getAttribute('data-nav-label');
      var link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = label;
      link.addEventListener('click', function(event) {
        var target = document.getElementById(heading.id);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + heading.id);
      });
      nav.appendChild(link);
    });

    if ('IntersectionObserver' in window) {
      var links = Array.from(nav.querySelectorAll('a'));
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          links.forEach(function(link) {
            link.classList.toggle('is-active', link.getAttribute('href') === '#' + entry.target.id);
          });
        });
      }, { rootMargin: '-18% 0px -72% 0px', threshold: 0 });
      headings.forEach(function(heading) { observer.observe(heading); });
    }
  }

  window.articleMagazineInit = initArticle;

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-article-magazine]').forEach(initArticle);
  });
  document.addEventListener('shopify:section:load', function(event) {
    event.target.querySelectorAll('[data-article-magazine]').forEach(initArticle);
  });
})();
